import React, { useEffect, useState, useReducer } from 'react';
import { Drawer, Form, Row, Col, Button, Input, notification } from 'antd';
import { AutoCompleteProduto } from '../auto-complete/AutoCompleteProduto';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLongArrowLeft } from '@fortawesome/pro-duotone-svg-icons';

import './AddItem.scss';
import { Estoque, Dinheiro } from '..';
import { InputDinheiro } from '../Numeros/input-dinheiro';
import { usePedido } from '../../services/usePedidos';
import { useSelector, useDispatch } from 'react-redux';
import { useEmpresas } from '../../hooks';
 


const AddItem = ({ visible, close/* , reducer, reducerProdutos */ }) => {

    const itemPadrao = {
        quantidade: 1,
        valorUn: 0,
        totalDescontos: 0,
        totalProduto: 0,
        totalItem: 0
    };
    const itemInicial = Object.assign({}, itemPadrao)

    const {getEmpresaSelecionada} = useEmpresas();

    const [produtoSelecionado, setProdutoSelecionado] = useState();
    const [isAdding, setIsAdding] = useState(false);

    const { addItemDb } = usePedido();



    const [item, setItem] = useState(itemInicial);
    //const {state, dispatch} = reducer;
    const reducerPedido = useSelector((state) => state.reducerPedido);
    const pedido = reducerPedido.pedido;
    const dispatch = useDispatch();

    useEffect(() => {
        const inputQtd = document.querySelector("#quantidade");
        if (inputQtd) {
            inputQtd.focus();
        }

        const timeout = setTimeout(() => {
            const searchProduto = document.querySelector("#searchProduto");
            if (searchProduto) {
                searchProduto.focus()
            }
        }, 100);

        return () => {
            clearTimeout(timeout);
        }
    }, [produtoSelecionado])

    const defineProdutoItem = (produto) => {
        setProdutoSelecionado(produto);
        const novoItem = produto ? Object.assign(item, { uuidProduto: produto.uuid }, { unidade: produto.uCom }) : Object.assign({}, itemPadrao);
        if (produto) {
            novoItem.valorUn = produto.vUnCom;

        }
        defineItem(novoItem);
    }

    const defineItem = (i) => {
        const totalProduto = i.quantidade * i.valorUn;
        const totalFrete = 0;
        const totalAcrescimos = 0;

        const totalItem = totalProduto - i.totalDescontos + totalFrete + totalAcrescimos;

        const novoItem = Object.assign(i, { totalProduto, totalItem, totalFrete, totalAcrescimos });
        setItem(novoItem);
    }





    const getWidth = () => {
        const w = window.innerWidth;
        if (w <= 768) {
            return w;
        }
        return 400;
    }

    useEffect(() => {
        if (visible) {
            resetForm();
            window.history.pushState({ name: 'addItem' }, "Adicionar Item");
        }
        const onPopState = () => {
            closeFn();
        }
        window.onpopstate = onPopState;

        const closeFn = () => {
            close();
        }

        return () => {
            window.removeEventListener('onpopstate', onPopState);
        }

    }, [visible])

    const resetForm = () => {
        const itemEmBranco = Object.assign({}, itemInicial);
        setProdutoSelecionado(false);
        setItem(itemEmBranco);
    }

    const closeForm = () => {
        window.history.back();
    }



    const setValor = (attr) => (valor) => {
        const novoItem = { ...item };
        novoItem[attr] = valor;
        defineItem(novoItem);
    }

    const addItem = async (evt) => {

        setIsAdding(true);
        setTimeout(async () => {
            try {
                const x = await addItemDb(pedido, item);

                setTimeout(async () => {
                    closeForm();
                    // setTimeout(() => dispatch({type: 'setPedido', payload: pedido}))
                    setTimeout(() => {
                        dispatch({ type: reducerPedido.reducerPedidoTypes.SET_PEDIDO, payload: x });
                        setIsAdding(false);
                    }, 200)
                    //       resetForm();    
                }, 250)
            } catch (error) {
                notification.error({
                    title: "Erro ao Inserir",
                    message: "Houve um problema ao inserir esse item ao pedido. Tente novamente."
                })
                setIsAdding(false);
            }
        }, 0)


    }

    const [usuarioNaoPodeAlterarValor, setUsuarioNaoPodeAlterarValor] = useState(false);


    useEffect(()=> {
        defineUsuarioNaoPodeAlterarValor();
    }, [true]);

    const defineUsuarioNaoPodeAlterarValor = async ()=> {
        const empresaSelecionada = await getEmpresaSelecionada(empresa => {});
        if(empresaSelecionada.permissoes && empresaSelecionada.permissoes.pedidos){
            const {itens=false} = empresaSelecionada.permissoes.pedidos;
            if(itens){
                const {alterarValor = true} = itens;
                setUsuarioNaoPodeAlterarValor(!alterarValor)
                return !alterarValor;
            }
        }

        setUsuarioNaoPodeAlterarValor(false);

        return false;
    }
    

    const desenhaDadosItemSelecionado = () => {
        if (produtoSelecionado && produtoSelecionado !== null) {
            return <>
                <Form.Item label="Quantidade" name="quantidade" initialValue={1} >
                    <Estoque
                        id="quantidade"
                        onValueChange={(novoValor) => setValor("quantidade")(novoValor.floatValue || 0)}
                        displayType="input"
                        customInput={Input}
                        type="text"
                        suffix={" " + (produtoSelecionado.uCom || "")}
                    />

                </Form.Item>

                <Form.Item label="Valor Unitário" name="valorUn">
                    <InputDinheiro readonly={usuarioNaoPodeAlterarValor} initialValue={produtoSelecionado.vUnCom} onChangeValue={setValor("valorUn")}></InputDinheiro>
                </Form.Item>

                <Form.Item className="ultimoFormItem" label={<>
                    Total Descontos &nbsp;
                </>} name="totalDescontos" >
                    <Input.Group>
                        <InputDinheiro readonly={usuarioNaoPodeAlterarValor} initialValue={produtoSelecionado.totalDescontos} onChangeValue={setValor("totalDescontos")}></InputDinheiro>

                    </Input.Group>
                </Form.Item>


                <Row gutter={16} className="totais">
                    <Col span={12} className="totalProduto">
                        <span className="label">
                            Total Produto
                        </span>
                        <Dinheiro className="total" value={item.totalProduto} ></Dinheiro>
                    </Col>
                    <Col span={12} className="totalItem">
                        <span className="label">
                            Total Item
                        </span>
                        <Dinheiro className="total" value={item.totalItem} ></Dinheiro>
                    </Col>
                </Row>
            </>;
        }
        return <></>;
    }

    return (<Drawer visible={visible} width={getWidth()}

        title={<>
            <Button type="text" size="small" onClick={closeForm}>
                <FontAwesomeIcon icon={faLongArrowLeft}></FontAwesomeIcon>
            </Button>
            Inserir Produto
        </>}

        footer={
            <div style={{ textAlign: "right" }}>
                <Button onClick={closeForm} type="link" size="large">Cancelar</Button>
                <Button type="primary" size="large" loading={isAdding} onClick={addItem}>Adicionar</Button>
            </div>
        }
    >
        <Form layout="vertical" className="formProduto">
            <Form.Item name="produto" label="Produto">
                <AutoCompleteProduto searchProps={{
                    size: "large",

                }}
                    autoCompleteProps={{
                        id: "searchProduto"
                    }}
                    key={produtoSelecionado}
                    produtoSelecionadoInicial={produtoSelecionado}
                    onSelect={defineProdutoItem}
                ></AutoCompleteProduto>
            </Form.Item>

            {desenhaDadosItemSelecionado()}



        </Form>
    </Drawer>);
}

export { AddItem };